import React from 'react'

const Logout = (props) => {
  props.handleLogout() 
  return null 
}

export default Logout



// WEBPACK FOOTER //
// ./src/Logout.js